export default defineNuxtPlugin((nuxtApp) => {
	nuxtApp.vueApp.provide('ui:header-navigation', [
		{ label: 'Dashboard', to: '/home/dashboard' },
		{ label: 'Account', to: '/home/account' },
		{ label: 'Mitglieder', to: '/home/members' },
	])
})
